import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoggedIn: localStorage.getItem('authToken') ? true : false, // 从 localStorage 初始化 isLoggedIn
    userId: localStorage.getItem('userId') || '',
    userPhone: localStorage.getItem('userPhone') || '',
    userInfo: null
  },
  mutations: {
    setLoggedIn(state, status) {
      state.isLoggedIn = status;
    },
    setUserId(state, userId) {
      state.userId = userId;
    },
    setUserPhone(state, userPhone) {
      state.userPhone = userPhone;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    }
  },
  actions: {
    async fetchUserInfo() {
      try {
        // 这里应该调用API获取用户信息
        // const response = await userApi.getUserInfo();
        // commit('setUserInfo', response.data);
      } catch (error) {
        console.error('获取用户信息失败:', error);
      }
    }
  },
  getters: {}
});